import { render, staticRenderFns } from "./carSelection.vue?vue&type=template&id=33ebb8c8&scoped=true&"
import script from "./carSelection.vue?vue&type=script&lang=ts&"
export * from "./carSelection.vue?vue&type=script&lang=ts&"
import style0 from "./carSelection.vue?vue&type=style&index=0&id=33ebb8c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ebb8c8",
  null
  
)

export default component.exports